export const ReducersTypes = {
  SIGNUP: "SIGNUP",
  LOGIN: "LOGIN",
  AUTH: "AUTH",
  DASHBOARD: "DASHBOARD",
  PAYABLES: "PAYABLES",
  NON_INVOICED: "NON_INVOICED",
  NAVIGATION: "NAVIGATION",
  NAVIGATION_RESET: "NAVIGATION_RESET",
  PAYMENT_METHODS: "PAYMENT_METHODS",
  RECEIVABLES: "RECEIVABLES",
  SETTINGS: "SETTINGS",
  SET_USER_STATE: "SET_USER_STATE",
  SET_USER_FILTER: "SET_USER_FILTER",
  SET_ADD_USER_DATA: "SET_ADD_USER_DATA",
  CONFIG_SETTINGS: "CONFIG_SETTINGS",
  RESET_CONFIG_SETTINGS: "RESET_CONFIG_SETTINGS",
  UPDATE_DISCOUNT_STATE: "UPDATE_DISCOUNT_STATE",
  UPDATE_RECEIVABLES_DATA: "UPDATE_RECEIVABLES_DATA",
  UPDATE_RECEIVABLES_STATE: "UPDATE_RECEIVABLES_STATE",
  CONFIRMATION_BOX: "CONFIRMATION_BOX",
  FETCH_ACTIVITY_LIST: "FETCH_ACTIVITY_LIST",
  FETCH_USERS_LIST: "FETCH_USERS_LIST",
  APPLY_USER_FILTER: "APPLY_USER_FILTER",
  CONFIRMATION_BOX_RESET: "CONFIRMATION_BOX_RESET",
  EMAIL_DATA: "EMAIL_DATA",
  EMAIL_RESET: "EMAIL_RESET",
  DYNAMIC_FORM: "DYNAMIC_FORM",
  ADD_DYNAMIC_FORM: "ADD_DYNAMIC_FORM",
  PREVIEW_DOCUMENT: "PREVIEW_DOCUMENT",
  RESET_PREVIEW_DOCUMENT: "RESET_PREVIEW_DOCUMENT",
  REPORTS: "REPORTS",
  REPORTS_CASH_IN_TOTAL: "REPORTS_CASH_IN_TOTAL",
  REPORTS_CASH_OUT_TOTAL: "REPORTS_CASH_OUT_TOTAL",
  REPORTS_ENDING_CASH_BALANCE: "REPORTS_ENDING_CASH_BALANCE",
  SET_REPORTS_CORPORATE_ENTITIES: "SET_REPORTS_CORPORATE_ENTITIES",
  RECALCULATE_REPORTS: "RECALCULATE_REPORTS",
  RESET_REPORTS: "RESET_REPORTS",
  LABEL_SETTINGS: "LABEL_SETTINGS",
  COMPARE_SCENARIOS: "COMPARE_SCENARIOS",
  RESET_COMPARE_SCENARIOS: "RESET_COMPARE_SCENARIOS",
  HEADER: "HEADER",
  HEADER_REFRESH_TOGGLE: "HEADER_REFRESH_TOGGLE",
  RESET_HEADER: "RESET_HEADER",
  SET_ACTIVE_APPLICATION_ANNOUNCEMENT: "SET_ACTIVE_APPLICATION_ANNOUNCEMENT",
  SET_TAG: "SET_TAG",
  RESET_TAG: "RESET_TAG",
  SET_DASHBOARD_DATA: "SET_DASHBOARD_DATA",
  SET_AR_AGING_BUCKETS_CONFIG: "SET_AR_AGING_BUCKETS_CONFIG",
  // CUSTOMER_LIST
  CUSTOMER_LIST: "CUSTOMER_LIST",
  CUSTOMER_LIST_TOTALS: "CUSTOMER_LIST_TOTALS",
  RESET_CUSTOMER_LIST: "RESET_CUSTOMER_LIST",
  CUSTOMER_LIST_FILTER: "CUSTOMER_LIST_FILTER",
  RESET_CUSTOMER_LIST_FILTER: "RESET_CUSTOMER_LIST_FILTER",
  CUSTOMER_LIST_UPDATE: "CUSTOMER_LIST_UPDATE",
  SET_NEW_CUSTOMER_FILTER: "SET_NEW_CUSTOMER_FILTER",
  RESET_NEW_CUSTOMER_FILTER: "RESET_NEW_CUSTOMER_FILTER",
  SET_CURRENT_CUSTOMER_WF: "SET_CURRENT_CUSTOMER_WF",
  // CUSTOMER_DETAILS
  CUSTOMER_DETAILS: "CUSTOMER_DETAILS",
  RESET_CUSTOMER_DETAILS: "RESET_CUSTOMER_DETAILS",
  CUSTOMER_DETAILS_CUSTOMER_REL_DATA: "CUSTOMER_DETAILS_CUSTOMER_REL_DATA",
  RESET_CUSTOMER_DETAILS_CUSTOMER_REL_DATA:
    "RESET_CUSTOMER_DETAILS_CUSTOMER_REL_DATA",
  CUSTOMER_DETAILS_FILTER: "CUSTOMER_DETAILS_FILTER",
  RESET_CUSTOMER_DETAILS_FILTER: "RESET_CUSTOMER_DETAILS_FILTER",
  CUSTOMER_DETAILS_REL_ID: "CUSTOMER_DETAILS_REL_ID",
  CUSTOMER_DETAILS_ID: "CUSTOMER_DETAILS_ID",
  RESET_CUSTOMER_DETAILS_REL_ID: "RESET_CUSTOMER_DETAILS_REL_ID",
  RESET_CUSTOMER_DETAILS_ID: "RESET_CUSTOMER_DETAILS_ID",
  CUSTOMER_DETAILS_TOTALS: "CUSTOMER_DETAILS_TOTALS",

  //UX
  INIT_UX: "INIT_UX",
  SET_UX: "SET_UX",
  RESET_UX: "RESET_UX",

  //User
  USER: "USER",
  USER_CLIENTS: "USER_CLIENTS",
  USER_SETTINGS: "USER_SETTINGS",
  USER_CORPORATE_ENTITIES: "USER_CORPORATE_ENTITIES",

  // Payment Analytics
  PAYMENT_ANALYTICS_LIST_FETCHING: "PAYMENT_ANALYTICS_LIST_FETCHING",
  PAYMENT_ANALYTICS_LIST_RESET: "PAYMENT_ANALYTICS_LIST_RESET",
  PAYMENT_ANALYTICS_LIST: "PAYMENT_ANALYTICS_LIST",
  PAYMENT_RECEIPT_FETCH: "PAYMENT_RECEIPT_FETCH",
  PAYMENT_ANALYTICS_LIST_FILTERS: "PAYMENT_ANALYTICS_LIST_FILTERS",
  // Autopay Accounts Report
  AUTOPAY_ACCOUNTS_LIST_FETCHING: "AUTOPAY_ACCOUNTS_LIST_FETCHING",
  AUTOPAY_ACCOUNTS_LIST: "AUTOPAY_ACCOUNTS_LIST",
  AUTOPAY_ACCOUNTS_LIST_RESET: "AUTOPAY_ACCOUNTS_LIST_RESET",
  AUTOPAY_ACCOUNTS_LIST_FILTERS: "AUTOPAY_ACCOUNTS_LIST_FILTERS",
  // Bank Balance Report
  BANK_BALANCE_REPORT_LIST_FETCHING: "BANK_BALANCE_REPORT_LIST_FETCHING",
  BANK_BALANCE_REPORT_LIST: "BANK_BALANCE_REPORT_LIST",
  BANK_BALANCE_REPORT_LIST_RESET: "BANK_BALANCE_REPORT_LIST_RESET",
  BANK_BALANCE_REPORT_LIST_FILTERS: "BANK_BALANCE_REPORT_LIST_FILTERS",
  HELP_PAGE_DETAILS_FETCH: "HELP_PAGE_DETAILS_FETCH",
  SKIP_AR_EMAIL_LIST_FETCH: "SKIP_AR_EMAIL_LIST_FETCH",
  FETCH_CLIENT_DATA: "FETCH_CLIENT_DATA",
  UPDATE_CLIENT_DATA: "UPDATE_CLIENT_DATA",
  SET_AI_TOKEN_PLANS: "SET_AI_TOKEN_PLANS",
  SET_AI_CLIENT_TOKEN_ASSIGNMENTS: "SET_AI_CLIENT_TOKEN_ASSIGNMENTS",
  ASSIGN_TOKEN_PLAN_TO_CLIENT: "ASSIGN_TOKEN_PLAN_TO_CLIENT",
  UPDATE_AI_CLIENT_TOKEN_ASSIGNMENTS: "UPDATE_AI_CLIENT_TOKEN_ASSIGNMENTS",
  SAVE_AI_TOKEN_PLAN: "SAVE_AI_TOKEN_PLAN",
  PAYROLL_SETTINGS_FETCH: "PAYROLL_SETTINGS_FETCH",
  PAYROLL_SETTINGS_UPDATE: "PAYROLL_SETTINGS_UPDATE",
  FETCH_CURRENCY_MAX_AMOUNTS_SUCCESS: "FETCH_CURRENCY_MAX_AMOUNTS_SUCCESS",
  FETCH_CURRENCY_MAX_AMOUNTS_FAILURE: "FETCH_CURRENCY_MAX_AMOUNTS_FAILURE",
  LOADING_CURRENCY_MAX_AMOUNTS: "LOADING_CURRENCY_MAX_AMOUNTS",
  DELETING_CURRENCY_MAX_AMOUNTS_ADD: "DELETING_CURRENCY_MAX_AMOUNTS_ADD",
  DELETING_CURRENCY_MAX_AMOUNTS_REMOVE: "DELETING_CURRENCY_MAX_AMOUNTS_REMOVE",
  // AR REP ASSIGNMENT (migrated to local reducer constants)
  //
  SET_PAYABLE_DATA: "SET_PAYABLE_DATA",
  SET_RECEIVABLE_DATA: "SET_RECEIVABLE_DATA",
  FETCH_TASK_LIST: "FETCH_TASK_LIST",
  EDIT_TASK_LIST: "EDIT_TASK_LIST",
  // Deduction Management
  SET_DEDUCTION_LIST: "SET_DEDUCTION_LIST",
  SET_DEDUCTION_FETCHING: "SET_DEDUCTION_FETCHING",
  SET_DEDUCTION_FILTERS: "SET_DEDUCTION_FILTERS",
  UPDATE_DEDUCTION: "UPDATE_DEDUCTION",
  DELETE_DEDUCTION: "DELETE_DEDUCTION",
  // Dispute Management
  FETCH_DISPUTE_LIST: "FETCH_DISPUTE_LIST",
  SET_DISPUTE_LIST: "SET_DISPUTE_LIST",
  SET_DISPUTE_FETCHING: "SET_DISPUTE_FETCHING",
  SET_APPROVAL_DISPUTE_LIST: "SET_APPROVAL_DISPUTE_LIST",
  SET_APPROVAL_DISPUTE_FETCHING: "SET_APPROVAL_DISPUTE_FETCHING",
  SET_DISPUTE_FILTERS: "SET_DISPUTE_FILTERS",
  EDIT_DISPUTE_LIST: "EDIT_DISPUTE_LIST",
  UPDATE_DISPUTE: "UPDATE_DISPUTE",
  DELETE_DISPUTE: "DELETE_DISPUTE",
  BULK_UPDATE_DISPUTE_STATUS: "BULK_UPDATE_DISPUTE_STATUS",
  SET_AR_DISPUTE_USER_LIST: "SET_AR_DISPUTE_USER_LIST",
  SET_DISPUTE_REASON_CODES: "SET_DISPUTE_REASON_CODES",
  SET_DISPUTE_EXPORTING: "SET_DISPUTE_EXPORTING",
  SET_DISPUTE_EXPORT_DATA: "SET_DISPUTE_EXPORT_DATA",
  EDIT_DISPUTES: "EDIT_DISPUTES",
  EDIT_DEDUCTIONS: "EDIT_DEDUCTIONS",

  USER_LIST_FETCH: "USER_LIST_FETCH",
  // Journal Entries
  FETCH_JOURNAL_INFLOW_LIST: "FETCH_JOURNAL_INFLOW_LIST",
  FETCH_JOURNAL_OUTFLOW_LIST: "FETCH_JOURNAL_OUTFLOW_LIST",
  FETCH_JOURNAL_INFLOW_DETAILS: "FETCH_JOURNAL_INFLOW_DETAILS",
  FETCH_JOURNAL_OUTFLOW_DETAILS: "FETCH_JOURNAL_OUTFLOW_DETAILS",
  SET_JOURNAL_INFLOW_FILTERS: "SET_JOURNAL_INFLOW_FILTERS",
  SET_JOURNAL_OUTFLOW_FILTERS: "SET_JOURNAL_OUTFLOW_FILTERS",
  SET_JOURNAL_CATEGORIES: "SET_JOURNAL_CATEGORIES",
  FETCH_JOURNAL_EXPORT: "FETCH_JOURNAL_EXPORT",
  RESET_JOURNAL_FILTERS: "RESET_JOURNAL_FILTERS",
  SET_JOURNAL_COLUMNS: "SET_JOURNAL_COLUMNS",
  // VENDOR_LIST
  VENDOR_LIST: "VENDOR_LIST",
  RESET_VENDOR_LIST: "RESET_VENDOR_LIST",
  SET_VENDOR_FILTER: "SET_VENDOR_FILTER",
  RESET_VENDOR_FILTER: "RESET_VENDOR_FILTER",
  VENDOR_LIST_UPDATE: "VENDOR_LIST_UPDATE",
  // Notes List
  SET_NOTES_LIST: "SET_NOTES_LIST",
  RESET_NOTES_LIST: "RESET_NOTES_LIST",
  SET_NOTES_LIST_FILTER: "SET_NOTES_LIST_FILTER",
  // Sms List
  SET_SMS_LIST: "SET_SMS_LIST",
  RESET_SMS_LIST: "RESET_SMS_LIST",
  SET_SMS_LIST_FILTER: "SET_SMS_LIST_FILTER",
  // Driver Activity
  SET_DRIVER_ACTIVITY_LIST: "SET_DRIVER_ACTIVITY_LIST",
  SET_DRIVER_INVOICE_LIST: "SET_DRIVER_INVOICE_LIST",
  SET_DRIVER_ACTIVITY_FILTER: "SET_DRIVER_ACTIVITY_FILTER",
  // CREDIT MANAGEMENT
  CREDIT_CUSTOMER_LIST: "CREDIT_CUSTOMER_LIST",
  CREDIT_CUSTOMER_FILTERS: "CREDIT_CUSTOMER_FILTERS",
  RESET_CREDIT_CUSTOMER_LIST: "RESET_CREDIT_CUSTOMER_LIST",
  CREDIT_CUSTOMER_DETAIL: "CREDIT_CUSTOMER_DETAIL",
  RESET_CREDIT_CUSTOMER_DETAIL: "RESET_CREDIT_CUSTOMER_DETAIL",
  CREDIT_OPEN_ITEMS: "CREDIT_OPEN_ITEMS",
  RESET_CREDIT_OPEN_ITEMS: "RESET_CREDIT_OPEN_ITEMS",
  CREDIT_APPROVAL_LIST: "CREDIT_APPROVAL_LIST",
  CREDIT_APPROVAL_FILTERS: "CREDIT_APPROVAL_FILTERS",
  RESET_CREDIT_APPROVAL_LIST: "RESET_CREDIT_APPROVAL_LIST",
  CREDIT_ALERT_LIST: "CREDIT_ALERT_LIST",
  CREDIT_ALERT_FILTERS: "CREDIT_ALERT_FILTERS",
  RESET_CREDIT_ALERT_LIST: "RESET_CREDIT_ALERT_LIST",
  CREDIT_DASHBOARD_DATA: "CREDIT_DASHBOARD_DATA",
  RESET_CREDIT_DASHBOARD_DATA: "RESET_CREDIT_DASHBOARD_DATA",
  CREDIT_RISK_CLASS_LIST: "CREDIT_RISK_CLASS_LIST",
  RESET_CREDIT_RISK_CLASS_LIST: "RESET_CREDIT_RISK_CLASS_LIST",
  SET_DRIVER_INVOICE_FILTER: "SET_DRIVER_INVOICE_FILTER",
  SET_SUPPLIER_REL_DETAILS: "SET_SUPPLIER_REL_DETAILS",
  // Carrier Report
  SET_CARRIER_ACTIVITY_LIST: "SET_CARRIER_ACTIVITY_LIST",
  RESET_CARRIER_ACTIVITY: "RESET_CARRIER_ACTIVITY",
  SET_CARRIER_ACTIVITY_FILTER: "SET_CARRIER_ACTIVITY_FILTER",
  // Invoicing Fields
  SET_INVOICING_FIELDS: "SET_INVOICING_FIELDS",
  // Phone Call
  SET_CALL_DATA: "SET_CALL_DATA",
  RESET_CALL_DATA: "RESET_CALL_DATA",
  INCREMENT_COUNTER: "INCREMENT_COUNTER",
  // Phone Call Reports List
  SET_CALL_LIST: "SET_CALL_LIST",
  RESET_CALL_LIST: "RESET_CALL_LIST",
  SET_CALL_LIST_FILTER: "SET_CALL_LIST_FILTER",
  // Vendor details
  SET_VENDOR_DETAILS_FILTER: "SET_VENDOR_DETAILS_FILTER",
  RESET_VENDOR_DETAILS_FILTER: "RESET_VENDOR_DETAILS_FILTER",
  SET_VENDOR_DETAILS_DATA: "SET_VENDOR_DETAILS_DATA",
  SET_VENDOR_DETAILS_DATA_TOTALS: "SET_VENDOR_DETAILS_DATA_TOTALS",
  // Receivables list
  SET_RECEIVABLE_LIST_DATA: "SET_RECEIVABLE_LIST_DATA",
  SET_RECEIVABLE_LIST_FILTERS: "SET_RECEIVABLE_LIST_FILTERS",
  RESET_RECEIVABLE_LIST_FILTERS: "RESET_RECEIVABLE_LIST_FILTERS",
  SET_RECEIVABLE_LIST_TOTALS: "SET_RECEIVABLE_LIST_TOTALS",

  // order backlog list
  SET_ORDER_BACKLOG_LIST_DATA: "SET_ORDER_BACKLOG_LIST_DATA",
  SET_ORDER_BACKLOG_LIST_FILTERS: "SET_ORDER_BACKLOG_LIST_FILTERS",
  RESET_ORDER_BACKLOG_LIST_FILTERS: "RESET_ORDER_BACKLOG_LIST_FILTERS",
  // Payables list
  SET_PAYABLES_LIST_DATA: "SET_PAYABLES_LIST_DATA",
  SET_PAYABLES_LIST_FILTERS: "SET_PAYABLES_LIST_FILTERS",
  RESET_PAYABLES_LIST_FILTERS: "RESET_PAYABLES_LIST_FILTERS",
  SET_PAYABLES_LIST_TOTALS: "SET_PAYABLES_LIST_TOTALS",
  // order backlog list
  SET_PURCHASE_ORDER_LIST_DATA: "SET_PURCHASE_ORDER_LIST_DATA",
  SET_PURCHASE_ORDER_LIST_FILTERS: "SET_PURCHASE_ORDER_LIST_FILTERS",
  RESET_PURCHASE_ORDER_LIST_FILTERS: "RESET_PURCHASE_ORDER_LIST_FILTERS",
  // Email report list
  SET_EMAIL_REPORT_LIST_DATA: "SET_EMAIL_REPORT_LIST_DATA",
  SET_EMAIL_REPORT_LIST_FILTERS: "SET_EMAIL_REPORT_LIST_FILTERS",
  RESET_EMAIL_REPORT_LIST_FILTERS: "RESET_EMAIL_REPORT_LIST_FILTERS",
  // Files report list
  SET_FILES_REPORT_LIST_DATA: "SET_FILES_REPORT_LIST_DATA",
  SET_FILES_REPORT_LIST_FILTERS: "SET_FILES_REPORT_LIST_FILTERS",
  RESET_FILES_REPORT_LIST_FILTERS: "RESET_FILES_REPORT_LIST_FILTERS",
  // Audit Logs
  FETCHING_AUDIT_LOGS: "FETCHING_AUDIT_LOGS",
  SET_AUDIT_LOGS_LIST_SUCCESS: "SET_AUDIT_LIST_SUCCESS",
  SET_AUDIT_LOGS_LIST_FAIL: "SET_AUDIT_LIST_FAIL",
  SET_AUDIT_LOGS_FILTERS: "SET_AUDIT_LOGS_FILTERS",
  //
  SET_TRANSLATION: "SET_TRANSLATION",
  //
  SET_WORKFLOW_SEQUENCE: "SET_WORKFLOW_SEQUENCE",
  RESET_WORKFLOW_SEQUENCE: "RESET_WORKFLOW_SEQUENCE",
  //
  SET_GUEST_USER_DATA: "SET_GUEST_USER_DATA",
  RESET_GUEST_USER_DATA: "RESET_GUEST_USER_DATA",

  // quotation and proformas
  SET_QUOTATION_AND_PROFORMA: "SET_QUOTATION_AND_PROFORMA",
  SET_QUOTATION_AND_PROFORMA_SUCCESS: "SET_QUOTATION_AND_PROFORMA_SUCCESS",
  SET_QUOTATION_AND_PROFORMA_FAIL: "SET_QUOTATION_AND_PROFORMA_FAIL",
  SET_QUOTATION_AND_PROFORMA_LOADING: "SET_QUOTATION_AND_PROFORMA_LOADING",

  // config variables
  SET_CONFIG_VARIABLES: "SET_CONFIG_VARIABLES",
  HELP_LINK: "HELP_LINK",

  //CASHAPP OLD
  SET_LOCKBOX_BATCHES: "SET_LOCKBOX_BATCHES",
  SET_LOCKBOX_BATCHES_FILTERS: "SET_LOCKBOX_BATCHES_FILTERS",
  SET_LOCKBOX_PAGINATION: "SET_LOCKBOX_PAGINATION",
  SET_LOCKBOX_LOADING: "SET_LOCKBOX_LOADING",
  SET_LOCKBOX_BATCH_DETAILS: "SET_LOCKBOX_BATCH_DETAILS",
  SET_LOCKBOX_FTP_CONFIG: "SET_LOCKBOX_FTP_CONFIG",

  // Remote Deposit
  SET_REMOTE_DEPOSIT_BATCHES: "SET_REMOTE_DEPOSIT_BATCHES",
  SET_REMOTE_DEPOSIT_BATCHES_FILTERS: "SET_REMOTE_DEPOSIT_BATCHES_FILTERS",
  SET_REMOTE_DEPOSIT_PAGINATION: "SET_REMOTE_DEPOSIT_PAGINATION",
  SET_REMOTE_DEPOSIT_BATCH_DETAILS: "SET_REMOTE_DEPOSIT_BATCH_DETAILS",
  SET_REMOTE_DEPOSIT_ITEMS: "SET_REMOTE_DEPOSIT_ITEMS",
  SET_REMOTE_DEPOSIT_ITEMS_FILTERS: "SET_REMOTE_DEPOSIT_ITEMS_FILTERS",
  SET_REMOTE_DEPOSIT_ITEMS_PAGINATION: "SET_REMOTE_DEPOSIT_ITEMS_PAGINATION",
  SET_REMOTE_DEPOSIT_ITEM_DETAILS: "SET_REMOTE_DEPOSIT_ITEM_DETAILS",
  SET_REMOTE_DEPOSIT_LOADING: "SET_REMOTE_DEPOSIT_LOADING",
  SET_REMOTE_DEPOSIT_UPLOAD_RESPONSE: "SET_REMOTE_DEPOSIT_UPLOAD_RESPONSE",

  // PayAdmin Management
  PAYADMIN_SET_INACTIVE_CUSTOMERS: "PAYADMIN_SET_INACTIVE_CUSTOMERS",
  PAYADMIN_SET_ARCHIVED_INVOICES: "PAYADMIN_SET_ARCHIVED_INVOICES",
  PAYADMIN_SET_AUDIT_LOGS: "PAYADMIN_SET_AUDIT_LOGS",
  PAYADMIN_RESET_INACTIVE_CUSTOMERS: "PAYADMIN_RESET_INACTIVE_CUSTOMERS",
  PAYADMIN_RESET_ARCHIVED_INVOICES: "PAYADMIN_RESET_ARCHIVED_INVOICES",
  PAYADMIN_RESET_AUDIT_LOGS: "PAYADMIN_RESET_AUDIT_LOGS",
  PAYADMIN_RESET_ALL: "PAYADMIN_RESET_ALL",

  // Collector Inbox - List
  SET_COLLECTOR_INBOX_LIST: "SET_COLLECTOR_INBOX_LIST",
  SET_COLLECTOR_INBOX_PAGINATION: "SET_COLLECTOR_INBOX_PAGINATION",
  SET_COLLECTOR_INBOX_FILTERS: "SET_COLLECTOR_INBOX_FILTERS",
  SET_COLLECTOR_INBOX_LOADING: "SET_COLLECTOR_INBOX_LOADING",

  // Collector Inbox - Thread Details
  SET_COLLECTOR_INBOX_THREAD_DETAILS: "SET_COLLECTOR_INBOX_THREAD_DETAILS",
  SET_THREAD_DETAILS_LOADING: "SET_THREAD_DETAILS_LOADING",
  SET_THREAD_SUMMARY: "SET_THREAD_SUMMARY",
  RESET_THREAD_DETAILS: "RESET_THREAD_DETAILS",

  // Thread Details - Emails Section
  SET_THREAD_EMAILS: "SET_THREAD_EMAILS",
  APPEND_THREAD_EMAILS: "APPEND_THREAD_EMAILS",
  PREPEND_THREAD_EMAILS: "PREPEND_THREAD_EMAILS",
  SET_THREAD_EMAILS_LOADING: "SET_THREAD_EMAILS_LOADING",
  SET_THREAD_EMAILS_FILTERS: "SET_THREAD_EMAILS_FILTERS",

  // Thread Details - Invoice Overview Section
  SET_THREAD_INVOICE_OVERVIEW: "SET_THREAD_INVOICE_OVERVIEW",
  SET_THREAD_INVOICE_OVERVIEW_LOADING: "SET_THREAD_INVOICE_OVERVIEW_LOADING",

  // Thread Details - Invoice Stats Section
  SET_THREAD_INVOICE_STATS: "SET_THREAD_INVOICE_STATS",
  SET_EMAIL_READ_STATUS: "SET_EMAIL_READ_STATUS",

  // Thread email - Draft Reply Section
  SET_DRAFT_REPLY: "SET_DRAFT_REPLY",
  RESET_DRAFT_REPLY: "RESET_DRAFT_REPLY",
  SET_DRAFT_REPLY_LOADING: "SET_DRAFT_REPLY_LOADING",
  SET_DRAFT_REPLY_IN_DRAFT: "SET_DRAFT_REPLY_IN_DRAFT",
  SET_APPROVE_AND_SEND_LOADING: "SET_APPROVE_AND_SEND_LOADING",
  SET_EMAIL_SELECTED_FOR_RESPONSE: "SET_EMAIL_SELECTED_FOR_RESPONSE",

  // Receivables Orchestration Engine
  SET_STUDIO_SETUP: "SET_STUDIO_SETUP",
  SET_PROMISE_TO_PAY: "SET_PROMISE_TO_PAY",
};
